export class ApiClientError extends Error {
  constructor(
    public readonly status: number,
    public readonly detail: {
      type?: string;
      title: string;
      status: number;
      detail?: string;
    },
  ) {
    super(detail.title);
    this.name = "ApiClientError";
  }
}

/**
 * プラン制限エラー (現在は HTTP 402 PAYMENT_REQUIRED) を判定する。
 *
 * 将来的に 403 + ProblemTypes.PLAN_REQUIRED への統一が予定されている (ADR-0057 §別 PR で対応)。
 * 統一後はこの関数の条件を `status === 403 && type === ProblemTypes.PLAN_REQUIRED` に更新すること。
 */
export function isPlanRequiredError(err: unknown): boolean {
  return err instanceof ApiClientError && err.status === 402;
}
